import { MenuFoldOutline, MenuUnfoldOutline, FormOutline, DashboardOutline } from '@ant-design/icons-angular/icons';

export const icons = [MenuFoldOutline, MenuUnfoldOutline, DashboardOutline, FormOutline];
